import { Helmet } from 'react-helmet'

import { Route, Switch, Redirect } from 'react-router-dom'

const ProposalRoutes = props => {
  const {
    name,
    routes,
    ...restProps
  } = props

  return (
    <>
      <Helmet
        key='helmet'
      >
        <title>{name}</title>
      </Helmet>
      <Switch>
        {
          routes.map(
            (route, i) => (
              <Route
                sensitive
                key={i}
                {...restProps}
                {...route}
              />
            )
          )
        }
        <Redirect
          to={{
            pathname: '/error',
            search: '?code=404',
            state: { errorMessage: '您的連結可能有誤，或您輸入的網址不存在！' }
          }}
        />
      </Switch>
    </>
  )
}

export default ProposalRoutes
